import { Component, computed, effect, inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicComponent, Register } from '@xanadu/core';
import { CommonSignal } from '@xanadu/signal';
import { TabSignal, TabSignalSet } from '@xanadu/signal';

@Component({
    selector: 'app-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('tab')
export class TabComponent extends DynamicComponent {
    private readonly router = inject(Router);
    private readonly tabSignal = inject(TabSignal);
    private readonly commonSignal = inject(CommonSignal);

    tabIndexes: Map<string, number> = new Map<string, number>();
    index: number = 0;
    tabUrls: Map<string, string> = new Map<string, string>();

    tabs = computed(() => {
        const model = this.model();
        return model ? model.tabs : [];
    });

    constructor(
    ) {
        super();

        effect(() => {
            const model = this.model();

            if (model) {
                if (model.tabs.length) {
                    model.tabs.forEach((tab: any, index: number) => {
                        this.tabIndexes.set(tab.path, index);
                        this.tabUrls.set(tab.path, tab.path);
                    });
                }
            }
        });

        effect(() => {
            const view = this.commonSignal.view();

            const model = this.model();
            if (model) {
                const tab = model.tabs[this.index];
                this.commonSignal.tab.set(tab);

                if (view) {
                    const name = view.name;
                    this.index = this.tabIndexes.get(name) ?? 0;

                    if (view.query) {
                        this.tabSignal.path[tab.path as keyof TabSignalSet<any>].set(view.query);
                    }
                }
            }
        });
    }

    public onSelect(event: number) {
        const model = this.model();

        let tab = model.tabs[this.index];
        if (tab) {
            this.tabUrls.set(tab.path, this.router.url);
        }

        tab = model.tabs[event];
        this.index = event;

        this.commonSignal.tab.set(tab);

        this.router.navigate([this.tabUrls.get(tab.path)]);
    }
}
